import React, { useEffect, useState } from 'react';
import API_BASE from '../config';
import { useLanguage } from '../contexts/LanguageContext';
import { useToast } from '../contexts/ToastContext';
import HomeLanding from './home/HomeLanding';
import { useHomeLanding } from './home/useHomeLanding';
import { useTawkTo } from './home/useTawkTo';

const Home: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  const toast = useToast();
  const lang = language === 'en' ? 'en' : 'cs';
  const v = useHomeLanding(lang);
  const [submitting, setSubmitting] = useState(false);
  useTawkTo();

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);

  const onContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (submitting) return;
    const form = e.currentTarget;
    const fd = new FormData(form);
    const payload = {
      firstName: String(fd.get('firstName') || '').trim(),
      lastName: String(fd.get('lastName') || '').trim(),
      email: String(fd.get('email') || '').trim(),
      companyName: String(fd.get('company') || '').trim(),
      companySize: String(fd.get('companySize') || '').trim(),
      subject: String(fd.get('subject') || '').trim(),
      message: String(fd.get('message') || '').trim(),
      newsletter: false,
    };
    if (!payload.firstName || !payload.lastName || !payload.email || !payload.subject || !payload.message) {
      toast.error(lang === 'cs' ? 'Vyplňte prosím povinná pole.' : 'Please fill in the required fields.');
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch(`${API_BASE}/api/contact/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        throw new Error(data.message || (lang === 'cs' ? 'Odeslání selhalo.' : 'Failed to send.'));
      }
      toast.success(lang === 'cs' ? 'Zpráva odeslána. Ozveme se brzy.' : 'Message sent. We will get back to you soon.');
      form.reset();
    } catch (err: any) {
      toast.error(err?.message || (lang === 'cs' ? 'Odeslání selhalo.' : 'Failed to send.'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <HomeLanding
      v={v}
      lang={lang}
      onSetCz={() => setLanguage('cs')}
      onSetEn={() => setLanguage('en')}
      onContactSubmit={onContactSubmit}
    />
  );
};

export default Home;
